export const KundenPageKey = "kunden-page";
export const KundenSearchValueKey = "kunden-searchValue";
export const KundenShowInactiveKey = "kunden-showInactive";
export const KundenTableSchemeKey = "kunden-tableScheme";
export const PackagesSearchValue = "packages-search-value";
export const ProjektSearchValue = "projekt-search-value";
export const ReportsSearchValue = "reports-search-value";
export const TestSearchValue = "test-search-value";
export const UserSearchValue = "user-search-value";
export const UserShowInactiveKey = "user-showInactive";

/** @var searchKeys - domain -> session storage keys */
export const searchKeys: Record<string, string[]> = {
  "/entwicklung": [ProjektSearchValue, PackagesSearchValue, TestSearchValue],
  "/kunde": [
    ReportsSearchValue,
    KundenSearchValueKey,
    KundenPageKey,
    KundenTableSchemeKey,
    KundenShowInactiveKey,
  ],
  "/administration": [UserSearchValue, UserShowInactiveKey],
};

export const LogViewerAutoRefresh = "csi.logViewer.autoRefresh";
export const LogViewerMinSeverity = "csi.logViewer.minSeverity";
export const LogViewerEntries = "csi.logViewer.entries";
export const LogViewerFileName = "csi.logViewer.fileName";
export const LogViewerShowAbsoluteTime = "csi.logViewer.showAbsoluteTime";
